import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getCompaniesBankAccounts } from 'modules/_common/api';

export const useQueryCompaniesBankAccounts = () =>
  useQuery(QUERY_KEYS.RENTALS_CALCULATION_LOGS, () => getCompaniesBankAccounts());
